import React , { useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { LinearProgress, FormControl, Typography, Breadcrumbs, Tooltip, Fab, CardContent, Grid, Drawer } 
from '@mui/material';
import But from '@mui/material/Button'
import { useTheme } from "@mui/material/styles";
import CardFooter from "../../components/Card/CardFooter.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import Tasks from "../../components/Tasks/Tasks.jsx";
import CustomTabs from "../../components/CustomTabs/CustomTabs.jsx";
//import Table from "../../components/Table/Table.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ListIcon from '@mui/icons-material/List';
import ViewListIcon from '@mui/icons-material/ViewList';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AddIcon from '@mui/icons-material/Add';
//import Table from "@mui/material/Table";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { baseUrl } from '../../components/shared/baseUrl';
import { mongoUrl } from '../../components/shared/mongoUrl';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';





const styles = (theme) =>({
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none",
      align: "center"
    },
    list: {
        width: 250,
      },
    listItemText:{
        fontSize:'50px',//Insert your required size
    }
  });


    export default function ViewClass(props) {
        const theme = useTheme()
        const classes = styles(theme);
        var interval = null
        const [clas, setclas] = React.useState([]);
        const [loading, setloading] = React.useState(true);
        const [sess, setsess] = React.useState([]);
        const [state, setState] = React.useState(false);
        const [sdetail, setsdetail] = React.useState({"title":'',"modId":''});
        const [query, setquery] = React.useState([]);
        const [sesQuery, setsesQuery] = React.useState([]);
        const [studentlist, setstudentlist]=React.useState([]);
        const [teacherlist, setteacherlist]=React.useState([]);
        const { classId } = useParams();
        



        useEffect(() => {

            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();
            
            const loadData=()=>{

            axios.get(`${baseUrl}class/${classId}`, { cancelToken: source.token })
            .then((response) => {
            setclas(response.data)
            const studentList = [];
            response.data.students.map((item, i) =>{
              //console.log(item)
              studentList.push(
                {
                  No:i+1,
                  Name:item.Name,
                  Email:item.Email
                }
              )
            })
            setstudentlist(studentList)
            
            const teacherList = [];
            response.data.coTeachers.map((item, i) =>{
              teacherList.push(
                {
                  No:i+1,
                  Email:item.Email
                }
              )
            })
            //console.log(teacherList.length)

            if(teacherList.length === 0){

              teacherList.push(
                {
                  No:0,
                  Email:'No teachers added/Go to Edit Class to add coTeachers'
                }
              )
            }
            setteacherlist(teacherList)

            const dat = Array.from(response.data.sessions)
            console.log(studentList)

            dat.map((map)=>{
              try{
                  ////Code to find matching grouplist with session id
                axios.get(`${baseUrl}pyinterpreter/profile`, { cancelToken: source.token })
                .then((response) => {
                console.log(response.data)
          
                const groupList = Array.from(response.data)
                const groupData = groupList
                
                console.log(groupData[0])
                var grpNo = 0;
                if(typeof groupData[0]!=='undefined'){
                groupData.map((grp) => {
                  grpNo++;
                  console.log(grp)
                  if(grp.support.length !== 0){
                    ///Set up query object for each sessions
                    const qry = {
                    supportChat: grp.support,
                    profileId: grp._id,
                    userId: grp.userId,
                    userNo: grpNo,
                    userName:grp.userName,
                    lastViewSupport:grp.lastViewSupport,
                    sessionId:map._id,
                    }
                    query.push(qry)
                  }
                })
              }
                
            })
            } catch (error) {
                if (axios.isCancel(error)) {
                  console.log("cancelled");
                } else {
                  throw error;
                }
              }
            })
            setsess(dat)
            const data = {
              lastViewed: new Date()
          }
          axios.put(`${baseUrl}class/${classId}`, data, { cancelToken: source.token })
          .then((res) =>{
              getData({dat})
            //   console.log(res.data);
            try{
              // interval = setInterval(() => {
              //     //console.log('Interval is working')
              //     getData({dat});
              // }, 3000);   
            } catch (error) {
                if (axios.isCancel(error)) {
                  console.log("cancelled");
                } else {
                  throw error;
                }
              }
              
              setloading(false)
          })
            //setloading(false)
    
            })
            .catch((error)=>{
            console.log(error);
            });
        };
            loadData();
            return () => {
                source.cancel();
            };

        }, []);
        console.log(query);

        const getData = ({dat}) =>{
          console.log(dat)
          const CancelToken = axios.CancelToken;
          const source = CancelToken.source();
        
            dat.map((map)=>{
              try{
                  ////Code to find matching grouplist with session id
                axios.get(`${baseUrl}pyinterpreter/profile`, { cancelToken: source.token })
                .then((response) => {
          
                const groupList = Array.from(response.data)
                const groupData = groupList
                
                console.log(groupData[0])
                var grpNo = 0;
                var qry=[];
                if(typeof groupData[0]!=='undefined'){
                groupData.map((grp) => {
                  grpNo++;
                  console.log(grp)
                  if(grp.support.length !== 0 && typeof(query.supportChat)!='undefined'){
                    ///Set up query object for each sessions
                    const length = query.supportChat.length;
                    qry = {
                    supportChat: grp.support,
                    profileId: grp._id,
                    userId: grp.userId,
                    userName:grp.userName,
                    userNo: grpNo,
                    lastViewSupport:grp.lastViewSupport,
                    sessionId:map._id,
                    }
                    
                   
                    
                  }
                })
                var len = query.length
                for(var i=0;i<len-1;i++){
                  query.pop()
                }
                  query.push(qry)
              }
                
            })
            } catch (error) {
                if (axios.isCancel(error)) {
                  console.log("cancelled");
                } else {
                  throw error;
                }
              }
            setsess(dat)
          
        })
        
      } 


        const toggleDrawer = (item, open) => (event) => {
            if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
              return;
            }
            //console.log(item)
            if(item!==null && open!==false){
                setsdetail(item.mod);
            }
            setState(!state);
          };
          

        ////function to return the corresponding session details for selected session  
        const findquery=(sdetail) =>{
          // console.log(sdetail)
          const sessionQuery= Array.from(query.filter((qry) => qry.sessionId === sdetail._id));

          //console.log(sessionQuery)
          if(sessionQuery.length !== 0){
            
            return sessionQuery
          }
        }
        // function to check for new queries 
        const writeQuery = (query, clas) => {
          console.log(query)
          const length = query.supportChat.length;
          //console.log(length)
          const time = new Date(query.supportChat[length-1].created).toString().substring(15, 21);

          const date = new Date(query.supportChat[0].created).toString().substring(3, 10);
          //if()
          const dateTime = date+time;
          ///check for new queries
          const lastMsg = new Date(query.supportChat[length-1].created)
          const lastVisit = new Date(query.lastViewSupport)
          var newQuery = false;
          console.log(lastVisit)

          if(lastVisit < lastMsg){
            newQuery = true
          }
          var nam = query.userName.substring(0,5)
            return(
              <ListItem key= {query.groupId}>
                  <ListItemText align="left" secondary={`${nam}`}> </ListItemText>
                  <Link color="inherit" to={`/admin/dashboard/viewclass/${clas._id}/viewquery/${sdetail._id}/${query.profileId}/${query.userId}`}>
                      <ListItemText>  view
                      {newQuery == true?'(New)' :null}  
                      </ListItemText>
                   </Link>
                   <ListItemText align="right" secondary={`${dateTime}`}></ListItemText>
              </ListItem>
              );
        }

        const sessionDetail = (sdetail) => {
  
            return(
              <ListItemText align='center'>
  
                <Link color="inherit" to={`/admin/dashboard/viewclass/${clas._id}/viewsession/${sdetail._id}`}>
                  <Button color="rose" variant="contained" size="sm" > view session</Button>
                </Link>                
              </ListItemText>
            );


        } 

          const list = (sdetail)=>(
            loading!==true?

            <div className={classes.list} role="presentation" onKeyDown={toggleDrawer(sdetail, false)}>

              <List>
                    {console.log(sdetail)}
                <ListItemText align='center'>Session Details</ListItemText>


                <ListItemText align='center'> {sdetail.title} </ListItemText>
              

                <ListItem button key='1'>
                  <ListItemText primary='Start' />
                  {datepartial(sdetail.start)}
                </ListItem>
                <ListItem button key='2'>
                  <ListItemText primary='Status' />
                  {sdetail.completed===false? 'Not completed' : 'completed' }
                </ListItem>
                {sessionDetail(sdetail)}

                <Divider/>
                
                <ListItemText align='center'>Need Attention</ListItemText>


                <ListItem key='5'>
                  <ListItemText primary={<Typography variant="body1" style={{ color: '#ff6f00' }}>Student</Typography>} />
                  <ListItemText primary={<Typography variant="body1" style={{ color: '#ff6f00' }}>Query</Typography>} />
                  <ListItemText primary={<Typography variant="body1" style={{ color: '#ff6f00' }}>Time</Typography>} />
                </ListItem>

                {/* {console.log(findquery(sdetail))} */}
                {typeof findquery(sdetail) !== 'undefined'?
                findquery(sdetail).map((query) =>(

                  // console.log(query)
                  writeQuery(query, clas)

                
                )):null}




              </List>

            </div> :null
          );

     //console.log(sdetail)
    
        function datepartial(date){
            
            var st = new Date(date).toString();
            return(
                st.substring(0, 21)
            );
        }

       function RenderSessionItem(mod){
            return(
                        //  <Link to={`/admin/dashboard/viewclass/${clas._id}/viewsession/${mod.modId}`}>

                             <Card>
                                  <CardContent>
                                    {console.log(mod.image)}
                                    {mod.image.substring(0,6)!=='assets'?
                                      <img alt={`${mod.title}`} className="card-img-top" src={mongoUrl+mod.image} />
                                      :<img alt={`${mod.title}`} className="card-img-top" src={baseUrl+mod.image} />}
                                    <Typography gutterBottom variant="h6" component="h4">
                                            {mod.title}
                                    </Typography>
                                    <Typography component="h5" variant="caption">
                                     {mod.completed===false ? ' Status: active' : ' Status: inactive' } |
                                     Start Date: {datepartial(mod.start)}

                                     {/* {new Date(mod.start).getDate()}-{new Date(mod.start).getMonth()+1}
                                     - {new Date(mod.start).getFullYear()}  */}

                                    </Typography>
                                    {/* <Typography component="p" variant="caption">
                                        Description: {mod.description}
                                    </Typography>
                                  </CardContent> */}
                                  <CardFooter>
                                    
                                    <div className="card-body text-center">
                                        <But
                                        size="large"
                                        variant="outlined"
                                        color="primary"
                                        className="mt-1" onClick={toggleDrawer({mod}, true)}>
                                            View
                                        </But>
                                    </div>
                                  </CardFooter>
                                  </CardContent>  
                            </Card>
                        // </Link>

          
            );
          }     

    
    //const studentlist = clas.students;
    //console.log(clas)

    //const teacherlist = clas.coTeachers;
    const slist=clas.sessions;
    const sessionlist = sess
    if(JSON.stringify(sessionlist)==='[]'){
        console.log('NO session added')
    }
   // console.log(sessionlist);

    const sesslist=sessionlist.map((ses) => {

        return (
                <GridItem xs={12} sm={6} md={3} key={ses._id}>
                    
                    {RenderSessionItem(ses)}
                  </GridItem>
                  
            );
          
        });

    
    return(

        (loading!==true?

        <GridContainer>
            <GridItem xs={12} sm={12} md={3}>

              <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                <Link color="inherit" to="/admin/dashboard">
                        Dashboard
                </Link>
                <Typography color="textPrimary">{clas.title}</Typography>
              </Breadcrumbs>
            </GridItem>
            {/* <GridItem xs={12} sm={12} md={7}>

                <Link to={`/admin/dashboard/createsession/${clas._id}`}> 

                    <Tooltip
                    arrow
                    title="Create new inquiry session"
                    placement="bottom">
                    <Fab
                    variant="extended"
                    color="secondary"
                    size="medium"
                    className="ml-3"
                    >
                    <AddIcon />
                            Create Session
                    </Fab>
                    </Tooltip>
                </Link>
            </GridItem> */}
            {/* <GridItem xs={12} sm={12} md={2}>
                <Link color="inherit" to={`/admin/dashboard/editclass/${clas._id}`}> 
                    <Button color="primary" >
                        Edit Class
                    </Button>
                 </Link>
            </GridItem> */}
            

            
            
        <GridItem xs={12} sm={12} md={12}>
          <CustomTabs
            title="Details:"
            headerColor="rose"
            tabs={[
              {
                tabName: "Inquiry Sessions",
                tabIcon: AssignmentIndIcon,
                 tabContent: 
                (
                //    <p>This tab contains inquiry session</p>
                <Grid>
                <Typography color="textPrimary" variant='h5'>Active Inquiry Sessions</Typography>

                <Grid container spacing={4}>
                    {JSON.stringify(sessionlist)!=='[]'? sesslist:<p>No Session added</p>}
                </Grid>

                <Typography color="textPrimary" variant='h5'>Inactive Inquiry Sessions</Typography>

                </Grid>

                )
              }
              // ,
              // {
              //   tabName: "Student List",
              //   tabIcon: ListIcon,
              //   tabContent: (
              //   <Table>
              //       <TableHead key={"header"}>
              //       {Object.keys(studentlist[0]).map((key) => (
              //           <TableCell>{key}</TableCell>
              //       ))}
              //       </TableHead>
              //   <TableBody>
              //       {studentlist.map((item) => (

              //       <TableRow key={item.id}>
              //           {Object.values(item).map((val) => (
              //           <TableCell>{val}</TableCell>
              //           ))}
              //       </TableRow>
              //       ))}
              //   </TableBody>
              // </Table>


              //   )
              // },
              // {
              //   tabName: "Teachers",
              //   tabIcon: ViewListIcon,
              //   tabContent: (

              //       <Table>
              //       <TableHead key={"header"}>
              //       {Object.keys(teacherlist[0]).map((key) => (
              //           <TableCell>{key}</TableCell>
              //       ))}
              //       </TableHead>
              //   <TableBody>
              //       {teacherlist.map((item) => (

              //       <TableRow key={item.id}>
              //           {Object.values(item).map((val) => (
              //           <TableCell>{val}</TableCell>
              //           ))}
              //       </TableRow>
              //       ))}
              //   </TableBody>
              // </Table>
              //   )
              // }
            ]}
          />
        </GridItem>
        <Drawer anchor={'right'} open={state} onClose={toggleDrawer(sdetail,false)}>
            
            {list(sdetail)}
        </Drawer>


        <GridItem xs={12} sm={12} md={4}>
                <Card>
                <CardHeader color="info" align="center">
                    <h4 className={classes.cardCategoryWhite}> About Class </h4>
                </CardHeader>
                <CardBody>
                    <p>standard: {clas.std}</p>

                </CardBody>
                </Card>
            </GridItem>


            


        </GridContainer>:null)

        


    );
}